import React, { FC, useCallback, useState } from 'react';
import { Icon, useOnClickOutside } from '@whitesharx/starfall-frontend-ui-kit';
import EmojiSelect, { EmojiSelectProps } from '../EmojiSelect/EmojiSelect';
import { buttonStyles } from './styles.css';

type EmojiButtonProps = {
  onSend?: EmojiSelectProps['onChoose'];
};

const EmojiButton: FC<EmojiButtonProps> = ({ onSend }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [element, setElement] = useState<HTMLDivElement | null>(null);

  const ref = useCallback((element: HTMLDivElement) => {
    setElement(element);
  }, []);

  useOnClickOutside(element, () => setIsOpen(false));

  const onEmojiChoose: EmojiSelectProps['onChoose'] = (...payload) => {
    onSend?.(...payload);
    setIsOpen(false);
  };

  return (
    <>
      <button onClick={() => setIsOpen(true)} className={buttonStyles}>
        <Icon name="bubble" size={{ width: '32px', height: '25px' }} color="white" />
      </button>
      {isOpen && <EmojiSelect ref={ref} onChoose={onEmojiChoose} />}
    </>
  );
};

export default EmojiButton;
